import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useMaincategory,
  useProject,
  useMain,
} from "../../actions/homeActions";
export default () => {
  const [allcategories, setAllcategories] = useState(true);
  const [seteledcategories, setSeteledcategories] = useState(false);
  const [jobHasMorePages, setEventsHasMorePages] = useState(false);
  const [additionalEvents, setAdditionalEvents] = useState([]);
  const [allEventCurrentPage, setAllProjectCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [categoriesTtypesProjectId, setCategoriesTtypesNewsId] = useState(null);
  const {
    data: CategoriesTypesProjects,
    isError,
    error,
  } = useMaincategory("projects");
  const baseURL = process.env.REACT_APP_BASE_URL;
  const {
    data: categoryProjects,
    isLoading,
    isError: newsListisError,
    error: newsListError,
  } = useMain(categoriesTtypesProjectId);
  const { data: allProjectData, isLoading: allProjectDataisloading } =
    useProject(allEventCurrentPage);

  useEffect(() => {
    if (allProjectData) {
      setEventsHasMorePages(allProjectData?.has_more_pages);
      setAdditionalEvents((prevProject) => {
        const newProject = allProjectData?.projects || [];
        const uniqueJobs = [...prevProject, ...newProject].reduce(
          (acc, project) => {
            if (!acc.some((j) => j.id === project.id)) {
              acc.push(project);
            }
            return acc;
          },
          []
        );
        return uniqueJobs;
      });
    }
  }, [allProjectData]);
  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading categories Ttypes News: {error.message}
        </p>
      </div>
    );
  }
  if (newsListisError) {
    return (
      <div className="flex items-center justify-center w-full">
        <p className="text-secondary">
          Error loading project List: {newsListError.message}
        </p>
      </div>
    );
  }
  const handleButtonClick = (id) => {
    setAllcategories(false);
    setSeteledcategories(true);
    setCategoriesTtypesNewsId(id);
  };

  const handleEvents = (id) => {
    navigate(`/project-details/${id}`);
  };

  return {
    setAllcategories,
    setSeteledcategories,
    CategoriesTypesProjects,
    handleButtonClick,
    allcategories,
    categoriesTtypesProjectId,
    allProjectData,
    additionalEvents,
    baseURL,
    handleEvents,
    allProjectDataisloading,
    jobHasMorePages,
    setAllProjectCurrentPage,
    seteledcategories,
    isLoading,
    categoryProjects,
  };
};
